// SermonsSection.jsx
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Modal } from 'react-bootstrap';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { makeGetRequest } from '../services/httpHelper';
import VideoCover from '../assets/images/videocover.jpg'


const Section = styled.section`
  padding: 60px 0;
  background-color: #fff;
`;

const SectionTitle = styled.h2`
  text-align: center;
  font-size: 2.2rem;
  margin-bottom: 30px;
  font-weight: 700;
`;

const StyledCard = styled(Card)`
  border: none;
  box-shadow: 0 0 15px rgba(0,0,0,0.05);
  transition: 0.3s;

  &:hover {
    transform: translateY(-5px);
  }

  .card-img-top {
    height: 180px;
    object-fit: cover;
  }
`;

const SermonsSection = () => {
  const navigate = useNavigate();
  const church = JSON.parse(localStorage.getItem('church')) || {};

  const [videoSermons, setVideoSermons] = useState([]);
  const [textSermons, setTextSermons] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState('');

  useEffect(() => {
    (async () => {
      const videoRes = await makeGetRequest(`video-sermons/${church.id}`);
      const textRes = await makeGetRequest(`text-sermons/${church.id}`);

      if (videoRes?.data) setVideoSermons(videoRes.data.slice(0, 4));
      if (textRes?.data) setTextSermons(textRes.data.slice(0, 4));
    })();
  }, []);


const openModal = (url) => {
  // Extract YouTube video ID
  let videoId = '';

  try {
    const urlObj = new URL(url);
    if (urlObj.hostname.includes('youtu.be')) {
      // Short URL format
      videoId = urlObj.pathname.slice(1);
    } else if (urlObj.hostname.includes('youtube.com')) {
      videoId = urlObj.searchParams.get('v');
    }
  } catch (e) {
    console.error('Invalid video URL:', url);
    return;
  }

  if (videoId) {
    const embedUrl = `https://www.youtube.com/embed/${videoId}`;

    setCurrentVideoUrl(embedUrl);
    
    setModalShow(true);
  } else {
    console.warn('Unable to extract video ID');
  }
};



  return (
    <Section>
      <Container>
        <SectionTitle>Video Sermons</SectionTitle>
        <Row>
          {videoSermons.map((sermon) => (
            <Col md={3} sm={6} key={sermon.id} className="mb-4">
              <StyledCard>
                <Card.Img variant="top" src={sermon.thumbnail || VideoCover} crossorigin="anonymous"/>
                <Card.Body>
                  <Card.Title>{sermon.title}</Card.Title>
                  <Button variant="primary" onClick={() => openModal(sermon.body)}>
                    Watch
                  </Button>
                </Card.Body>
              </StyledCard>
            </Col>
          ))}
        </Row>
        <div className="text-center mt-3">
          <Button variant="outline-primary" onClick={() => navigate(`/${church.website}/sermons/videos`)}>Explore More</Button>
        </div>

        <hr className="my-5" />

        <SectionTitle>Text Sermons</SectionTitle>
        <Row>
          {textSermons.map((sermon) => (
            <Col md={3} sm={6} key={sermon.id} className="mb-4">
              <StyledCard>
                <Card.Body>
                  <Card.Title onClick={() => navigate(`/sermons/text/${sermon.id}`)} style={{ cursor: 'pointer' }}>
                    {sermon.title}
                  </Card.Title>
                  <Card.Text><strong>{sermon.speaker}</strong></Card.Text>
                  <Card.Text><small>{new Date(sermon.date).toLocaleDateString()}</small></Card.Text>
                </Card.Body>
              </StyledCard>
            </Col>
          ))}
        </Row>
        <div className="text-center mt-3">
          <Button variant="outline-primary" onClick={() => navigate(`/${church.website}/sermons/text`)}>Explore More</Button>
        </div>

        {/* Video Modal */}
         <Modal
        size="lg"
        centered
        show={modalShow}
        onHide={() => setModalShow(false)}
        backdrop="static"
        animation={false}
        dialogClassName="video-modal"
      >
       <Modal.Header style={{ backgroundColor: '#000', borderBottom: 'none' }}>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={() => setModalShow(false)}
          style={{
            filter: 'invert(1)',
            position: 'absolute',
            top: '10px',
            right: '10px',
            zIndex: 1051,
          }}
        />
      </Modal.Header>
        <Modal.Body style={{ padding: 0, backgroundColor: '#000' }}>
          <div style={{ position: 'relative', paddingTop: '56.25%' }}>
            <iframe
              title="Sermon Video"
              src={`${currentVideoUrl}?autoplay=1&rel=0`}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 'none',
                transform: 'translateZ(0)',
              }}
            />
          </div>
        </Modal.Body>
      </Modal>

      </Container>
    </Section>
  );
};

export default SermonsSection;
